import { useState } from "react";

interface I_Login {
    onSuccess: () => void
}

const Login = ({ onSuccess }: I_Login) => {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (event: React.FormEvent) => {
        event.preventDefault();
        setBusy(true);

        const response = await fetch("/api/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ password })
        });
        const body = await response.json().catch(() => ({}));

        setBusy(false);

        if (!response.ok) {
            setError(body?.error || "Anmeldung fehlgeschlagen");

            return;
        }

        setPassword("");
        onSuccess();
    };

    return (
        <form className="login" onSubmit={submit}>
            <h1>TBGeoData</h1>
            <p className="subtitle">Bitte Passwort eingeben</p>

            <input
                type="password"
                autoFocus
                autoComplete="current-password"
                placeholder="Passwort"
                value={password}
                onChange={(event) => {
                    setPassword(event.target.value);
                    setError("");
                }}
            />

            {error && <p className="error">{error}</p>}

            <button className="primary" type="submit" disabled={busy || !password}>
                {busy ? "Wird geprüft …" : "Anmelden"}
            </button>
        </form>
    )
}
export default Login;